import { getTranslatedLabel } from 'src/utils/locale.util'
import { useTranslation } from 'react-i18next'
import { TNavigationLocales } from 'src/types/locales'
import { useFollowupFormContext } from './generic-followup-form.component'

interface Props {
  isEditMode: boolean
}
function GenericFollowupHeader({ isEditMode }: Readonly<Props>) {
  const { i18n } = useTranslation()
  const locale = i18n.language as TNavigationLocales
  const { configUI } = useFollowupFormContext()
  if (
    !getTranslatedLabel(locale, configUI?.followupUI?.patientDetails?.textIntro) &&
    !getTranslatedLabel(locale, configUI?.followupUI?.form?.textIntro)
  ) {
    return null
  }

  return (
    <div className="c-pt-2 c-text-grey-600">
      {isEditMode ? (
        getTranslatedLabel(locale, configUI?.followupUI.patientDetails?.textIntro) && (
          <p className="c-font-nexa">
            {getTranslatedLabel(locale, configUI?.followupUI.patientDetails?.textIntro)}
          </p>
        )
      ) : (
        <>
          {getTranslatedLabel(locale, configUI?.followupUI.form?.textIntro) && (
            <p className="c-font-nexa">{getTranslatedLabel(locale, configUI?.followupUI.form?.textIntro)}</p>
          )}
          {getTranslatedLabel(locale, configUI?.followupUI.form?.disclaimer) && (
            <p className="c-font-nexa c-text-grey-500">
              {getTranslatedLabel(locale, configUI?.followupUI.form?.disclaimer)}
            </p>
          )}
        </>
      )}
    </div>
  )
}

export default GenericFollowupHeader
